import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getPermissions(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.PERMISSIONS.GET_PERMISSIONS, action.payload, true);
}

export function* getPermissionsMatrix(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.PERMISSIONS.GET_PERMISSIONS_MATRIX, action.payload, true);
}

export function* getPermissionsModuleJobs(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.PERMISSIONS.GET_PERMISSIONS_MODULE_JOBS, action.payload, true);
}
